module.exports = "//public.getcloudapp.com/packs/media/images/icons-embed-bordered-dcfe9ad824e0c62872b990298f8f5490.png";